export const zhCNAgentGuiComposer = {
  loadingOptions: "正在加载",
  composerOptionsLoadFailed: "配置加载失败",
  composerOptionsRetry: "重试",
  composerOptionsRetryTooltip: "共享 Agent 信息加载失败，点击重试",
  sendFailed: "消息未能发送",
  returnToConversation: "回到会话",
  continueAnswering: "继续回答",
  inheritedUnavailable: "继承 / 不可用",
  modelConsumptionSpeedLabel: "消耗速度",
  modelConsumptionMultiplierSuffix: "倍率"
};
